export const DOCS__PERMISSIONS = {
  KNOWLEDGE_BASE: {
    VIEW: {
      permissionGroupName: 'Przeglądanie kolekcji, modułów i artykułów w bazie wiedzy',
      NONE: {
        dbName: 'DOCS__KNOWLEDGE_BASE__VIEW__NONE',
        name: 'Brak uprawnień',
        description: 'Brak dostępu do przeglądania kolekcji, modułów i artykułów w bazie wiedzy.'
      },
      PUBLISHED_OR_ASSIGNED: {
        dbName: 'DOCS__KNOWLEDGE_BASE__VIEW__PUBLISHED_OR_ASSIGNED',
        name: 'Opublikowane lub przypisane',
        description: [
          'Możesz:',
          '- przeglądać opublikowane kolekcje (przypisane rolą, bezpośrednio lub widoczne domyślnie dla wszystkich)',
          '- przeglądać moduły oraz opublikowane wersje artykułów w tych kolekcjach'
        ].join('\n')
      }
    },
    MANAGE: {
      permissionGroupName: 'Zarządzanie bazą wiedzy',
      NONE: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__NONE',
        name: 'Brak uprawnień',
        description: 'Brak możliwości zarządzania bazą wiedzy.'
      },
      ASSIGNED: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__ASSIGNED',
        name: 'Tylko przypisane kolekcje',
        description: [
          'Możesz:',
          '- tworzyć, edytować i archiwizować artykuły (publiczne i niepubliczne) w kolekcjach przypisanych rolą lub bezpośrednio',
          '- ustawiać artykuły widoczne tylko dla zalogowanych użytkowników',
          '- przeglądać archiwum artykułów oraz wszystkie wersje artykułów',
          '- edytować przypisane kolekcje (bez tworzenia nowych)'
        ].join('\n')
      },
      ASSIGNED_AND_CREATE: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__ASSIGNED_AND_CREATE',
        name: 'Przypisane + tworzenie kolekcji',
        description: ['Dodatkowo:', '- tworzyć własne kolekcje'].join('\n')
      },
      ALL: {
        dbName: 'DOCS__KNOWLEDGE_BASE__MANAGE__ALL',
        name: 'Wszystkie kolekcje',
        description: [
          'Dodatkowo:',
          '- tworzyć, edytować i archiwizować artykuły we wszystkich kolekcjach (także bez opublikowanych artykułów)',
          '- tworzyć, edytować i publikować wszystkie kolekcje',
          '- zarządzać rolami i użytkownikami przypisanymi do kolekcji',
          '- korzystać z widoku admina bazy wiedzy'
        ].join('\n')
      }
    }
  }
} as const
